var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[(_vm.showSoundFile)?_c('dl',{staticClass:"pdf"},[_c('dt',[_vm._v("音声ファイル")]),_c('dd',[_c('a',{attrs:{"href":_vm.soundFile.fileUri,"target":"_blank"}},[_vm._v(_vm._s(_vm.soundFile.fileName))])])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }